/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type PatientAuthorizationUtilizationState = typeof PatientAuthorizationUtilizationState[keyof typeof PatientAuthorizationUtilizationState];


export const PatientAuthorizationUtilizationState = {
  Available: 'Available',
  Upcoming: 'Upcoming',
  Expired: 'Expired',
  Exhausted: 'Exhausted',
  PartlyExhausted: 'PartlyExhausted',
} as const;
